<template>
    <div>
      <b-row class="mt-3">
        <b-col cols="5">
          <b-form-group label="Report Type: "  :label-cols="3" >
            <b-form-select class="form-control input" v-model="reportType" disabled>
              <option :value="null"  >--Please Select Type--</option>
                <option value="monthwise">Month Wise</option>
              </b-form-select>          
          </b-form-group> 
        </b-col>

        <b-col cols="5">
          <b-form-group label="Hub : "  :label-cols="3" >
            <b-form-select class="form-control input" v-model="destinationhubid" :disabled="isSuperAdmin!=1">
              <option :value="null"  >--Please Select Hub--</option>
                <option v-for="hub in hublist"   v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
              </b-form-select>          
          </b-form-group> 
        </b-col>

        <b-col cols="4">
          <b-form-group label="Select Month: "  :label-cols="4">
            <date-picker 
              v-model="selectedMonth" 
              format="MM-YYYY" 
              type="month" 
              placeholder="Please Select Month"
              :disabled-date="disabledDate"
            ></date-picker>         
          </b-form-group> 
        </b-col>
        
        <b-col cols="4">

        </b-col>

        <b-col cols="2" style="text-align:left;">
          <b-form-group>
            <button class="btn btn-primary" @click="getHubMonthWiseRVPListing(1)"> Search </button>                       
            <button class="btn btn-danger ml-1" @click="refresh()"> <i class="fa fa-refresh"></i> </button>                       
          </b-form-group>
        </b-col>
        
        <b-col cols="2" style="text-align:right;">
            <b-form-group>
              <button class="btn btn-primary" @click="performanceReport" :disabled="totalRows==0">Download </button>                       
            </b-form-group>
        </b-col>
      </b-row>

      <b-row class="my-2"> 
        <b-col sm="12" class="text-right">
          <b-col sm="12">  
            <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
          </b-col>
        </b-col> 

        <b-col sm="12">
          <b-table 
            show-empty 
            responsive
            :items="items" 
            :busy="isBusy" 
            :current-page="currentPage"
            :fields="fields" 
            :per-page="perPage" 
            :bordered="bordered">

            <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>

            <template slot="totalreturnrvp" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'totalreturnrvp')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.totalreturnrvp }}</span>
              </button>
            </template>

            <template slot="totalpickup" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'totalpickup')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.totalpickup }}</span>
              </button>
            </template>

            <template slot="totalpending" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'totalpending')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.totalpending }}</span>
              </button>
            </template>

            <template slot="totalcancel" slot-scope="row">
              <button title="View Details" @click="viewDetails(row.item,'totalcancel')" style="background-color: white !important;" class="btn btn-link">
                <span style="color:#1b8eb7">{{ row.item.totalcancel }}</span>
              </button>
            </template>

          </b-table>
        </b-col>

        <b-col sm="12" class="my-1" v-if="this.totalRows>10">
          <paginate 
            :page-count="noofpages"
            :page-range="10"
            :margin-pages="2"
            :click-handler="clickCallback"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :current-page="currentPage"
          >
          </paginate>
        </b-col> 

        <b-modal size="xl" title="Details" v-model="detailsModal" hide-footer>
          <b-row>
            <b-col sm="12" class="text-right">
              <p > <b>Total Records :<span style="color:red;">{{ totalRowsCount }}</span></b> </p>
            </b-col>

            <b-col sm="8" class="my-1">
              <paginate 
                :page-count="noofpages1"
                :page-range="10"
                :margin-pages="2"
                :click-handler="handleCountDetails"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                v-model="currentPage1"
              >
              </paginate>
            </b-col> 

            <b-col sm="4" class="text-right">
              <b-form-group>
                <button class="btn btn-primary" @click="countDetailsReport" :disabled="totalRowsCount==0">Download </button>                       
              </b-form-group>
            </b-col>

            <b-col sm="12">
              <b-table
                show-empty 
                responsive 
                :items="items1" 
                :busy="isBusy1" 
                :fields="fields1"
                :per-page="perPage1" 
                :bordered="bordered"
              >

              <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>

              </b-table>
            </b-col>

            <b-col sm="12" class="my-1">
              <paginate 
                :page-count="noofpages1"
                :page-range="10"
                :margin-pages="2"
                :click-handler="handleCountDetails"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                v-model="currentPage1"
              >
              </paginate>
            </b-col> 
          </b-row>
        </b-modal>
      </b-row>

    </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
  export default {
    components: {
      DatePicker
    },
    data: function(){
      return{
        name:'hubWiseRVPReport_KSA',
        isBusy: false,
        items: [],
        fields: [
          {key:'hub_name',label:'HUB Name'},
          {key:'rvpmonth',label:'Month'},
          {key:'totalreturnrvp',label:'Total Return (RVP Creation Date)'},
          {key:'totalpickup',label:'Total Pickup'},
          {key:'total_pickup_percentage',label:'Total Pickup Percentage'},
          {key:'totalpending',label:'Total Pending'},
          {key:'total_pending_percentage',label:'Total Pending Percentage'},
          {key:'totalcancel',label:'Total RVP Cancelled'},
          {key:'total_cancel_percentage',label:'Total RVP Cancelled Percentage'},
        ],
        bordered: true,
        totalRows: 0,
        currentPage: 1,
        perPage:10,
        noofpages: 0,
        destinationhubid:null,
        reportType:'monthwise',
        hublist:[],
        selectedMonth:new Date(),
        toMonth:null,
        downloadreport:'',
        isSuperAdmin:0,

        //modal fields
        detailsModal:false,
        isBusy1: false,
        items1:[],
        fields1:[
          {key:'shippingid',label:'Shipping Id [Order Id]'},
          {key:'hub_name',label:'Pickup Location Name'},
          {key:'servicetype',label:'Service Type'},
          {key:'shipmentstatus',label:'Shipment Status'},
          {key:'deliverystatus',label:'Delivery Status'},
          {key:'agent_name',label:'Agent Name'},
          {key:'customer_name_no',label:'Customer Name & Mob No.'},
          {key:'vendor_name',label:'Vendor Name'},
          {key:'da_mo_no',label:'DA Mobile Number'},
          {key:'delivery_addr',label:'Delivery Address'},
          {key:'ordertype',label:'Order Type'},
          {key:'createddate',label:'Created Date'},
          {key:'lastmodifieddate',label:'Last Modified Date'}
        ],
        totalRowsCount:0,
        currentPage1: 1,
        noofpages1: 0,
        perPage1:50,
        countDetails: {},
        countName: '',
      }
    },
    created: function(){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      this.isSuperAdmin = userInfo.is_superadmin
      var hubId = userInfo.pickuplocationmasterid;
      this.destinationhubid= this.isSuperAdmin != 1 ? hubId : null
      this.getHublist();
      //this.getHubMonthWiseRVPListing(1)
    },

    methods:{
      getHublist: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;
        var hubobj={
          hub_id:currenthub.toString()
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,hubobj)
        .then(result => {
          if(result.body.returnmsg=='Successful'){
            this.hublist = result.body.returnvalue;
          }
        })
        .catch(ex => {
          console.log('error', ex)
        });
      },

      getHubMonthWiseRVPListing: function(pageNo){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)

        this.isBusy = true;

        if(!this.destinationhubid){
          this.$fire({
            text: "Please Select Hub!!!",
            type: "warning",
            timer: 30000
          }); 
          this.isBusy = false;
          return
        }

        if(this.selectedMonth == null || this.selectedMonth == undefined){
          this.$fire({
            text: "Please Select Month",
            type: "warning",
            timer: 30000
          }); 
          this.isBusy = false;
          return 
        }
        else{
          const Obj = {
            month:this.formatMonth(this.selectedMonth),
            hub_id: this.destinationhubid ? this.destinationhubid.toString():"",
            limit: this.perPage,
            page_no: pageNo ? pageNo : 1     
          }

          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubwiseRVPReportListing`,Obj)
          .then(result=>{
            if(result.status==200){
              if(result.body && result.body.returnmsg === 'Successful'){
                this.items = result.body.returnvalue;
                this.totalRows = result.body.totalCount;
                this.noofpages=parseInt(this.totalRows)/this.perPage;
                this.noofpages=Math.ceil( this.noofpages);
                console.log("noofpages-->",this.noofpages)
              }
              else{
                this.items = [];
                this.totalRows = 0;
                this.noofpages = 0;
                this.$fire({
                  text: result.body.returnvalue,
                  type: "warning",
                  timer: 30000
                });
              }
            }else{
              this.items = [];
              this.totalRows = 0;
              this.noofpages = 0;
              this.$fire({
                text: "Error while fetching Data!!!",
                type: "warning",
                timer: 30000
              });
            }
            
             this.isBusy = false;
            })
          .catch(ex =>{
            this.items = [];
            this.totalRows = 0;
            this.noofpages = 0;
            this.$fire({
              text: "Error while fetching Data!!!",
              type: "warning",
              timer: 30000
            });
            this.isBusy = false;
            console.log('error',ex)
          })
        }
      },

      performanceReport(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var hubId = userInfo.pickuplocationmasterid;

        const Obj={
          month:this.formatMonth(this.selectedMonth),
          hub_id: this.destinationhubid ? this.destinationhubid.toString():"",
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubwiseRVPReportCsv`,Obj)
        .then(result=>{

          if(result.body){
            this.downloadReport(result.body)
          }
          else{
            this.downloadreport='';
          }
        })
        .catch(ex=>{
          console.log('error',ex)
        })
      },

      downloadReport(data){
        const csvData = data
        console.log("Data for download---> ",csvData);
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + csvData;
        anchor.download = 'hubMonthWiseRVPReport.csv';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      },

      viewDetails(data,name){
        this.countDetails = data,
        this.countName = name,
        this.items1=[];
        this.totalRowsCount=0;
        this.noofpages1=0;
        this.currentPage1=1;
        this.detailsModal=true;
        this.displayHubRVPMonthWiseDetails(1);
      },

      displayHubRVPMonthWiseDetails:function(pageNo){
        console.log("details api called")
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        this.isBusy1 =true;

        const Obj = {
          month: this.countDetails.rvpmonth,
          hub_id : this.countDetails.hub_id.toString(),
          count_name: this.countName,
          limit: this.perPage1,
          page_no: pageNo ? pageNo : 1,
          // downloadAsCSV: 'false'
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubwiseRVPReportCountDetails`,Obj)
        .then(result=>{
          if(result.status==200){
            if(result.body && result.body.returnmsg === 'Successful'){
              this.items1=result.body.returnvalue;
              this.totalRowsCount=result.body.totalCount;
              this.noofpages1=parseInt(this.totalRowsCount)/this.perPage1;
              this.noofpages1=Math.ceil( this.noofpages1);
              //this.detailsModal=true;
            }
            else{
              //this.detailsModal=false;
              this.items1=[];
              this.totalRowsCount=0;   
              this.noofpages1=0,    
              this.$fire({
                text:result.body.returnvalue,
                type: "warning",
                timer: 30000
              }); 
            }
          }else{
            this.items1=[];
            this.totalRowsCount=0;   
            this.noofpages1=0,  
            this.$fire({
              text: "Error while fetching Data!!!",
              type: "warning",
              timer: 30000
            });
          }
          
          this.isBusy1 = false;
        })
        .catch(ex=>{
          this.items1=[];
          this.totalRowsCount=0;   
          this.noofpages1=0,  
          this.$fire({
            text: "Error while fetching Data!!!",
            type: "warning",
            timer: 30000
          });
          this.isBusy1 = false;
          console.log('error',ex)
        })

      },

      disabledDate(date) {
        let today = new Date();
        let startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        let endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        return date > endOfMonth;
      },

      clickCallback(pageNo){
        this.getHubMonthWiseRVPListing(pageNo)
      },

      handleCountDetails(pageNo){
        this.currentPage1=pageNo;
        this.displayHubRVPMonthWiseDetails(pageNo);
      },

      countDetailsReport(){
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)

        const Obj={
          month: this.countDetails.rvpmonth,
          hub_id : this.countDetails.hub_id.toString(),
          count_name: this.countName,
          limit: this.perPage1,
          page_no: 1, 
          downloadAsCSV: 'true'
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getHubwiseRVPReportCountDetails`,Obj)
        .then(result=>{

          if(result.body){
            this.downloadCountReport(result.body)
          }
          else{
            this.downloadcountdetailsreport='';
          }
        })
        .catch(ex=>{
          console.log('error',ex)
        })
      },

      downloadCountReport(data) {
        const csvData = data;
        console.log("Data for download---> ", csvData);

        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
        const anchor = document.createElement('a');
        const url = URL.createObjectURL(blob);

        anchor.href = url;
        anchor.download = 'hubMonthWiseRVPReportCountDetails.csv';

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        URL.revokeObjectURL(url);
      },

      formatMonth: function(date){
        var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        return [month, year].join("-");
      },

      refresh(){
        if(this.isSuperAdmin == 1){
          this.destinationhubid=null;
        }
        this.selectedMonth = new Date();
        this.items = [];
        this.totalRows = 0;
        this.noofpages = 0;
        //this.getHubMonthWiseRVPListing(1);
      },
    }
  }

</script>

<style>

</style>